import { z } from 'zod'
import { TPromptSchema } from '@/model/tPromptDto'

const UserSchema = z.object({
  uuid: z.string(),
  name: z.string(),
  email: z.string()
})

export const TPromptReferenceSchema = z.object({
  uuid: z.string(),
  name: z.string()
})

export const OrganisationCustomizationSchema = z.object({
  uuid: z.string().optional(),
  name: z.string().nullable().default(null),
  description: z.string().nullable().default(null),
  colorScheme: z.array(z.string()).default([]),
  propertiesMap: z.record(z.union([z.array(z.string()), z.record(z.string())])).default({}),
  tprompt: TPromptReferenceSchema.nullable().default(null)
})

export const OrganisationSchema = z.object({
  name: z.string().default(''),
  uuid: z.string().default('')
})

export const ExtendedOrganisationSchema = OrganisationSchema.extend({
  telefonNummer: z.any(),
  steuerNummer: z.any(),
  adresse: z.any(),
  subscriptionName: z.string().optional(),
  subscriptionTier: z.string().optional(),
  subscriptionActive: z.boolean().optional(),
  subscriptionState: z.string().optional(),
  accountType: z.enum(['SELF_SERVICE', 'ENTERPRISE', 'FREE']).optional(),
  stripeCustomerID: z.string().optional(),
  customization: z
    .object({
      uuid: z.string().optional(),
      name: z.string().nullable().default(null),
      description: z.string().nullable().default(null),
      colorScheme: z.array(z.string()).default([]),
      propertiesMap: z.record(z.union([z.array(z.string()), z.record(z.string())])).default({}),
      tprompt: TPromptReferenceSchema.nullable().default(null)
    })
    .optional(),
  organisationCustomization: z
    .object({
      uuid: z.string().optional(),
      name: z.string().nullable().default(null),
      colorScheme: z.array(z.string()).default([]),
      propertiesMap: z.record(z.array(z.string())).optional(),
      tprompt: TPromptSchema.nullable().default(null)
    })
    .default({}),
  users: z.array(UserSchema).optional(),
  numberOfSeats: z.number().optional(),
  numberOfUsedSeats: z.number().optional()
})

export const UpdateOrganisationSchema = OrganisationSchema.extend({
  telefonNummer: z.any(),
  steuerNummer: z.any(),
  adresse: z.any(),
  subscriptionName: z.string().optional(),
  subscriptionTier: z.string().optional(),
  subscriptionActive: z.boolean().optional(),
  stripeCustomerID: z.string().optional(),
  organisationCustomization: OrganisationCustomizationSchema,
  users: z.array(UserSchema).optional(),
  numberOfSeats: z.number().optional(),
  numberOfUsedSeats: z.number().optional()
})

export type Organisation = z.infer<typeof OrganisationSchema>
export type ExtendedOrganisationSchema = z.infer<typeof ExtendedOrganisationSchema>
export type UpdateOrganisationSchema = z.infer<typeof UpdateOrganisationSchema>
export type OrganisationCustomization = z.infer<typeof OrganisationCustomizationSchema>
